import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AdsService } from '../../services/ads.service';

@Component({
  selector: 'app-pendingads',
  templateUrl: './pendingads.component.html',
  styleUrls: ['./pendingads.component.scss']
})
export class PendingadsComponent implements OnInit {

  pendingAds:any;
  cancellationReason: boolean;
  cancellationReasonForm: FormGroup;
  cancellationArray:any = [];
  submitted = false;

  constructor(private adsService: AdsService) { }

  ngOnInit(): void {
    this.adsService.getPendingAds().then((res:any) => {
      console.log(res)
      if (res.ads.data.country == 123) {this.pendingAds.country = "Lebanon"}
      this.pendingAds=res.ads.data
      
      console.log(this.pendingAds)
    })
    
  }

 

  showCancellation(id) {
    this.cancellationReason = true;
    this.cancellationArray.id = id;
    console.log(this.cancellationArray.id)

  }

  hideCancellation() {
    this.cancellationReason = false;
    this.submitted = false;
    // this.cancellationReasonForm.reset();
  }

  acceptEvent(id){
    this.adsService.acceptPendingAd(id, "approved").then((res:any) => {
      console.log(res)
      for (let i=0; i<this.pendingAds.length; i++) {
        if (this.pendingAds[i].id === id){
          this.pendingAds.splice(i,1);
        }
      }
    })
  }

  rejectEvent(){
    this.adsService.acceptPendingAd(this.cancellationArray.id, "rejected").then((res) => {
      console.log(res);
      for (let i=0; i<this.pendingAds.length; i++) {
        if (this.pendingAds[i].id === this.cancellationArray.id){
          this.pendingAds.splice(i,1);
        }
      }
      this.cancellationReason = false;
    })
  }
}
